import React, { FC, useMemo, useState } from 'react';

import smsConfig from 'configs/sms';

import { cn, resultIf } from '../../../../utils';

import './InputSmsCode.scoped.scss';

type Props = {
  onChange: (code: string) => void;
  code: string;
};

const smsCodeLength = smsConfig.smsCodeLength > 0 ? smsConfig.smsCodeLength : 6;

const InputSmsCode: FC<Props> = ({ onChange, code }) => {
  const [focused, setFocused] = useState(false);

  const active = () => {
    return focused || code !== '';
  };

  const renderCode = useMemo(() => {
    //TODO: CHANGE REGEXP TO INSERT WHITESPACES AFTER AND NOT BEFORE
    return code.replace(/.{1,2}(?=(.{2})+$)/g, '$& ').trim();
  }, [code]);
  const handleChange = (newCode: string): void => {
    const actualCode = newCode.replace(/\D/g, '').slice(0, smsCodeLength);
    onChange(actualCode);
  };
  return (
    <div className={cn('input-sms-code', resultIf(active(), 'active'))}>
      <label htmlFor="input-sms-code" className="input-sms-code__label">
        Проверочный код
      </label>
      <input
        id="input-sms-code"
        value={renderCode}
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        pattern="[0-9]*"
        className="input-sms-code__input"
        onInput={(event) => handleChange((event.target as HTMLInputElement).value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
    </div>
  );
};

export default InputSmsCode;
